import React ,{Component} from 'react';
import Loader from "../../loader";
import Grid from '@material-ui/core/Grid';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import customStyle from "../../../Assets/CSS/stylesheet_UHS";
import Button from "@material-ui/core/Button";
import customeClasses from "./Eligibility.css";
import axios from 'axios';
import DateFnsUtils from '@date-io/date-fns';
import configurations from "../../../configurations";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import {MuiPickersUtilsProvider, KeyboardDatePicker,DatePicker} from '@material-ui/pickers';
import {connect} from "react-redux";
import {Modal} from "react-bootstrap";
import {TableContainer, Radio, Table, TableCell,Paper, TableBody, TableHead, TableRow, FormControl, TextField, RadioGroup, FormControlLabel } from '@material-ui/core';
import "./Add-ons/addOnsScreen.css"
import moment from 'moment';

const PurpleRadio = withStyles(
    customStyle.radioBtn
)(props => <Radio color="default" {...props} />);

const ACSMCheckbox = withStyles({
    root: {
        color: '#23436c',
        "&$checked": {
            color: '#23436c',
        },
        "&$disabled": {
            color: 'grey'
        }
    },
    checked: {},
    disabled: {
        color: 'grey'
    }
})(Checkbox);

const styles = props => (
    customStyle.chkEligiScreen
);

const CssTextField = withStyles(theme => ({
    root: {
      '& .MuiInput-root': {
      "&:hover:not($disabled):not($focused):not($error):before": {
       borderBottom: '2px solid #23436c'
      },
     
    '&.MuiInput-underline.Mui-focused:after':{
      borderBottom: '2px solid #23436c',
  },
    
   }
  },
  }))(TextField);
const WizardButton = withStyles(
    customStyle.viewNetwellBtn
)(Button);

const ProceedButton = withStyles(
    customStyle.proceedNetwellBtn
)(Button);
const ViewButton = withStyles(
    customStyle.viewNetwellBtn
)(Button);

const NextButton = withStyles(
    customStyle.NextButton
)(Button);


class DateSelection extends Component{
    constructor(props) {
        super(props);
        this.state = {
            headerData : [],
            addOnsBodyData : [],
            loaderShow : true,
            progress : 0,
            count : 0,
            tableData : null,
            healthTool : false,
            membersArr : [],
            popTable : null,
            moreInfoModal : false,
            check:false,
            minDate: new Date(),
            subID: JSON.parse(localStorage.getItem('CurrentLoginUser')).id,
            myDate: moment().add(1, 'days'),
            recurringDay: 1,
            selectedDateRecurringPayment: new Date(),
            radioSelected: "Today",
            saveddataHistory: null,
            validEffectiveDates: [],
            selectedEffectiveDate: null,
            dateValidationError: null,
        }
    }
    
    // Helper function to calculate valid effective dates (1st or 15th within 30 days)
    calculateValidEffectiveDates = () => {
        const today = moment();
        const validDates = [];
        const maxDaysAhead = 30;

        // Scan next 30 days and include every 1st/15th option
        for (let dayOffset = 1; dayOffset <= maxDaysAhead; dayOffset++) {
            const candidateDate = moment(today).add(dayOffset, 'days');
            const dayOfMonth = candidateDate.date();

            if (dayOfMonth === 1 || dayOfMonth === 15) {
                validDates.push({
                    date: candidateDate.format('YYYY-MM-DD'),
                    label: candidateDate.format('MMMM D, YYYY'),
                    daysAhead: dayOffset
                });
            }
        }
        
        // Sort by date
        validDates.sort((a, b) => moment(a.date).diff(moment(b.date)));
        
        // Set validation error if no valid dates
        if (validDates.length === 0) {
            this.setState({
                dateValidationError: 'Coverage start dates must be within 30 days. Please contact support.',
                validEffectiveDates: []
            });
        } else {
            this.setState((prevState) => {
                const hasPreviousSelection = prevState.selectedEffectiveDate && validDates.some(
                    (dateOption) => dateOption.date === prevState.selectedEffectiveDate
                );
                const nextSelectedDate = hasPreviousSelection
                    ? prevState.selectedEffectiveDate
                    : validDates[0].date;

                return {
                    validEffectiveDates: validDates,
                    selectedEffectiveDate: nextSelectedDate,
                    myDate: moment(nextSelectedDate),
                    dateValidationError: null
                };
            });
        }
    }

    componentDidMount=()=> {
        // Calculate valid effective dates (1st or 15th within 30 days)
        this.calculateValidEffectiveDates();
        
        this.getPaymentMode();
        let subId = JSON.parse(localStorage.getItem('CurrentLoginUser')).id;
        axios.get(process.env.REACT_APP_BASE_URL + "/enrollment/saveCompletionStatus/" + subId + "/" + this.props.activeStep)
        .then((response) => {
          if (response && response.data.code === 200) console.log(response.data.code)
        })
        .catch((error) => console.log(error));

        axios.get(process.env.REACT_APP_BASE_URL+"/plan/getTotalAmount"+`/${subId}`).then((resp)=>{
            this.setState({loaderShow: false})
            if(resp.data.response){
                this.setState({tableData: resp.data.response})
                console.log("::::", resp.data.response)
            }
        })

        axios.get(process.env.REACT_APP_BASE_URL+"/plan/getMemberPlan"+`/${this.state.subID}/Core`).then((resp)=>{
            this.setState({loaderShow: false})
            if(resp.data.response){
                const apiTargetDate = resp.data.response.targetDate
                    ? moment(resp.data.response.targetDate).format('YYYY-MM-DD')
                    : null;
                this.setState((prevState) => {
                    const updates = {
                        saveddataHistory: resp.data.response
                    };

                    if (apiTargetDate && apiTargetDate !== "Invalid date") {
                        updates.selectedEffectiveDate = apiTargetDate;
                        updates.myDate = moment(apiTargetDate);

                        const alreadyPresent = prevState.validEffectiveDates.some(
                            (dateOption) => dateOption.date === apiTargetDate
                        );

                        if (!alreadyPresent) {
                            const apiDateMoment = moment(apiTargetDate);
                            const today = moment();
                            const updatedEffectiveDates = [
                                ...prevState.validEffectiveDates,
                                {
                                    date: apiTargetDate,
                                    label: apiDateMoment.format('MMMM D, YYYY'),
                                    daysAhead: apiDateMoment.diff(today, 'days')
                                }
                            ].sort((a, b) => moment(a.date).diff(moment(b.date)));

                            updates.validEffectiveDates = updatedEffectiveDates;
                        }
                    }

                    return updates;
                })
            }
        })
    }

    getPaymentMode = () => {
        fetch(`${configurations.baseUrl}/setuppayment/getPaymentDetails/${this.props.subId}`)
            .then((response) => response.json())
            .then((response) => {
                if (response.response) {
                    if (response.response.paymentType === "ACH") 
                        this.setState({ minDate: moment().add(5, 'days'), recurringDay: 5 })
                    else this.setState({ minDate: moment().add(1, 'days'), recurringDay: 1 })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    handleBack = () =>{
        this.props.onClickjumpfive();
    }

    handleProceed = (e) =>{
        // Validate that a valid effective date is selected
        if (!this.state.selectedEffectiveDate) {
            this.setState({
                dateValidationError: 'Please select a valid coverage start date.'
            });
            return;
        }
        
        // Validate 30-day rule
        const selectedDate = moment(this.state.selectedEffectiveDate);
        const today = moment();
        const daysAhead = selectedDate.diff(today, 'days');
        
        if (daysAhead > 30) {
            this.setState({
                dateValidationError: 'Coverage start date must be within 30 days. Please contact support.'
            });
            return;
        }
        
        // Validate that selected date is 1st or 15th
        const dayOfMonth = selectedDate.date();
        if (dayOfMonth !== 1 && dayOfMonth !== 15) {
            this.setState({
                dateValidationError: 'Coverage can only start on the 1st or 15th of the month.'
            });
            return;
        }
        
        let obj = {
            "subId": this.state.subID,
            "effectiveDate": this.state.selectedEffectiveDate,
            "draftDate": moment(this.state.selectedDateRecurringPayment).format("YYYY-MM-DD"),
            "paymentDay": this.state.radioSelected
        }
        
        if(e.detail === 1)
        axios.post(process.env.REACT_APP_BASE_URL+"/plan/updateMemberPlan", obj).then((resp)=>{
             this.props.onClick();
        })
       
    }
    handleEffectiveDateChange = (event) => {
        const selectedDate = event.target.value;
        this.setState({
            selectedEffectiveDate: selectedDate,
            myDate: moment(selectedDate),
            dateValidationError: null
        });
    }
    
    render() {
        const { classes } = this.props;
        
        let currentScreen = <Grid container spacing={2} row>
            <Grid item xs={12} sm={3}>
                <div style={{textAlign : 'justify', width : '95%', marginBottom: '20px'}}>
                    Please select the effective start date that will be applicable for your plan and add-ons.
                </div>
                
                {this.state.dateValidationError ? (
                    <div style={{
                        padding: '15px', 
                        backgroundColor: '#ffebee', 
                        color: '#c62828', 
                        borderRadius: '4px',
                        marginBottom: '15px',
                        fontSize: '14px',
                        border: '1px solid #ef5350'
                    }}>
                        <strong>Error:</strong> {this.state.dateValidationError}
                    </div>
                ) : null}
                
                <div style={{marginTop: '10px'}}>
                    <div style={{
                        fontWeight: 'bold', 
                        marginBottom: '10px',
                        fontSize: '16px',
                        color: '#23436c'
                    }}>
                        Coverage Start Date:
                    </div>
                    
                    {this.state.validEffectiveDates.length > 0 ? (
                        <FormControl component="fieldset">
                            <RadioGroup
                                aria-label="effective-date"
                                name="effective-date"
                                value={this.state.selectedEffectiveDate}
                                onChange={this.handleEffectiveDateChange}
                            >
                                {this.state.validEffectiveDates.map((dateOption, index) => (
                                    <FormControlLabel
                                        style={{ marginBottom: 0 }}
                                        key={index}
                                        value={dateOption.date}
                                        control={<PurpleRadio />}
                                        label={
                                            <span>
                                                <strong>{dateOption.label}</strong>
                                                {/* <span style={{color: '#666', marginLeft: '10px'}}>
                                                    ({dateOption.daysAhead} days out)
                                                </span> */}
                                            </span>
                                        }
                                        disabled={this.props.isChangeProgram || this.props.isHouseholdUpdate}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                    ) : (
                        <div style={{
                            padding: '15px',
                            backgroundColor: '#fff3e0',
                            color: '#e65100',
                            borderRadius: '4px',
                            fontSize: '14px',
                            border: '1px solid #ffb74d'
                        }}>
                            No valid coverage start dates available within 30 days. Please contact support.
                        </div>
                    )}
                    
                    {/* <div style={{
                        marginTop: '15px',
                        padding: '10px',
                        backgroundColor: '#e3f2fd',
                        borderRadius: '4px',
                        fontSize: '13px',
                        color: '#1565c0'
                    }}>
                        <strong>Note:</strong> Coverage can only begin on the 1st or 15th of the month, 
                        and must be within 30 days from today.
                    </div> */}
                </div>
            </Grid>
            <Grid item xs={12} sm={2} />
            <Grid item xs={12} sm={7}>
                <div>
                    <div style={{textAlign : 'justify', width : '95%', marginBottom:20}}>
                        Also take note of the <b>Key Payment Dates</b> mentioned below and select when you would like your first payment to be processed.
                    </div> 
                    <div className="addOnTable reviewChoice" style={{width : '100%', overflowX : 'auto'}}>
                    {       
                        this.state.tableData && this.state.saveddataHistory && <CommonTable recurringDay={this.state.recurringDay} effectiveDate={this.state.selectedEffectiveDate ? this.state.selectedEffectiveDate : moment(this.state.myDate).format('YYYY-MM-DD')} saveddataHistory={this.state.saveddataHistory} tableData={this.state.tableData} radioSelected={(val) => this.setState({radioSelected: val})} selectedDateRecurringPayment={(val)=> this.setState({selectedDateRecurringPayment: val})}/>
                    }
                    </div>
                    <p style={{marginTop: 5}}>*The actual date may vary based on the number of days in the month</p>
                </div>
            </Grid>
        </Grid>
        

        return (
            <div style={{flexGrow: 1}}>
                {
                    this.state.loaderShow ? <Loader></Loader> : ''
                }
                <Grid container style={{ fontFamily : 'Roboto, Arial, Helvetica, sans-serif', fontSize : '14px'}}>
                   

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        {currentScreen}
                    </Grid>
                    <Grid item xs={12} sm={10} md={6} style={{marginTop : '25px'}}>
                        <Grid container spacing={3}>
                        

                            <Grid item xs={4} sm={3}>
                                <ProceedButton disabled={false}
                                               variant="contained" style={{width : '100%'}}
                                               onClick={this.handleProceed}>Done
                                </ProceedButton>
                                {/*style={{width: '104px', height: '40px'}}*/}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

           

            </div>
        );
    }
    handleAddOn(){
        if(!this.state.check)
        this.setState({check:true})
        else
        this.setState({check:false})
    }
}

const mapStateToProps = state => {
    return {
        subId: state.subId,
        email : state.email
    };
}


export default withStyles(styles)(connect(mapStateToProps)(DateSelection));



const CommonTable = (props) => {
    const [openCustomDatepopup, setCustomDatePopup] = React.useState(false);
    const [radioSelected, setRadioSelected] = React.useState("Today");
    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const [futureDate, setfutureDate] = React.useState(new Date());
    const effectiveDateMoment = React.useMemo(() => moment(props.effectiveDate), [props.effectiveDate]);
    const minSelectableDate = React.useMemo(() => moment(futureDate), [futureDate]);
    const maxSelectableDate = React.useMemo(() => moment(props.effectiveDate).subtract(1, 'days'), [props.effectiveDate]);
    React.useEffect(() => {
  
        if(props.saveddataHistory && props.saveddataHistory.paymentDay){
            setRadioSelected(props.saveddataHistory.paymentDay);
            setSelectedDate(props.saveddataHistory.draftDate);
        }
    }, [])
    const answerChangeHandler = (value) =>{
        setRadioSelected(value);
        if(value === "Custom")
        setCustomDatePopup(true)
        else
        setSelectedDate(new Date())
    }
    const setIsPickerOpen = (value) =>{
        if (!value) {
            setCustomDatePopup(false)
            return;
        }
        setSelectedDate(value)
        setCustomDatePopup(false)
    }
    const setDateCustom = () =>{
        setCustomDatePopup(true);
        setRadioSelected("Custom")
    }
    React.useEffect(()=>{
        props.selectedDateRecurringPayment(selectedDate);
    }, [selectedDate]);
    React.useEffect(()=>{
        setSelectedDate((prevDate) => {
            const prevMoment = moment(prevDate);
            if (!prevMoment.isValid()) {
                return minSelectableDate.toDate();
            }
            if (prevMoment.isBefore(minSelectableDate)) {
                return minSelectableDate.toDate();
            }
            if (maxSelectableDate.isValid() && prevMoment.isAfter(maxSelectableDate)) {
                return maxSelectableDate.toDate();
            }
            return prevDate;
        });
    },[props.effectiveDate, minSelectableDate, maxSelectableDate])
    React.useEffect(()=>{
        props.radioSelected(radioSelected);
    }, [radioSelected])
    return ( 
      <>
        <TableContainer component={Paper}>
          <Table  sx={{ minWidth: "100%", fontWeight: "Lato" }} aria-label="customized table">
            <TableHead>
              <TableRow style={{ backgroundColor: "#b31b44"}}>
                
                {props.tableData.header.map((data) => <TableCell style={{padding: 11, width:"auto"}}><b style={{color: "#fff"}}>{data}</b></TableCell>)}
                
                <TableCell style={style} align="left">
                <b style={{color: "#fff"}}>Date</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow style={{ borderBottom : '2px solid #23436c',}}>
                <TableCell style={{ padding: 11,  background:"#f2f2f2" }} component="th" scope="row">
                <p style={{color: "#000", marginBottom: 0}}>{props.tableData.body[0].text}</p>
                </TableCell>
                <TableCell style={{ padding: 11,  background:"#f2f2f2" }} component="th" scope="row" align="left">
                <p style={{color: "#000", marginBottom: 0}}><b>{props.tableData.body[0].amount}</b></p>
                </TableCell>
                <TableCell style={{ padding: 11,  background:"#f2f2f2" }} align="left">
        
                <div>
                {/* <RadioGroup
                 
                  aria-label="days"
                  name="row-radio-buttons-group"
                  value={radioSelected}
                  onChange={(event) =>
                    answerChangeHandler(event.target.value)
                  }
                >
                  <FormControlLabel
                    value="Today"
                    control={<PurpleRadio />}
                    label="Date of application submission"
                  />
                  <div onClick={() => setDateCustom()}>
                    <FormControlLabel
                    value="Custom"
                    control={<PurpleRadio />}
                    label="Custom"
                  />
                  
                  <CalendarTodayIcon style={{fontSize: 18, marginTop: "-8px", cursor: "pointer"}}/>
                </div>
                </RadioGroup> */}
                <CalendarTodayIcon onClick={() => setDateCustom()} style={{fontSize: 18, marginTop: "-3px", cursor: "pointer"}} /> <span>Payment Date: <b>{moment(selectedDate).format("MMM DD, YYYY")}</b></span>
              
              </div>
            
                </TableCell>
              </TableRow>
  
              <TableRow style={{ borderBottom : '2px solid #23436c', background: "#fff"}}>
                <TableCell className='dateSelection' style={{ padding: 11,  background:"#f2f2f2" }} component="th" scope="row">
                <p style={{color: "#000", marginBottom: 0}}>{props.tableData.body[1].text}</p>
                </TableCell>
                <TableCell  style={{ padding: 11,  background:"#f2f2f2" }}  component="th" scope="row" align="left">
                <p style={{color: "#000", marginBottom: 0}}><b>{props.tableData.body[1].amount}</b></p>
                </TableCell>
                <TableCell  style={{ padding: 11,  background:"#f2f2f2" }}  align="left">{moment(effectiveDateMoment).subtract(props.recurringDay, 'days').format("Do")} of every month*</TableCell>
              </TableRow>
            
            </TableBody>
          </Table>
        </TableContainer>

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    InputProps={{readOnly: false}}
                    onChange={(e) => setIsPickerOpen(e)}
                    value={selectedDate}
                    open={openCustomDatepopup}
                    minDate={minSelectableDate}
                    maxDate={maxSelectableDate}
                    style={{display: "none"}}
                    onClose={() => setCustomDatePopup(false)} 
                    />
            </MuiPickersUtilsProvider>
      </>
    );
  };
  const style={
    padding: 11,
  }
  